<div class="button-container">
	<button class="btn btn-sm cv-btn-blue" (click)="onAddPackage()">
		<i class="fas fa-plus-square"></i> Add New Package
	</button>
</div>

<div class="inbox-datatable__main-content scrollable-component">
	<cv-input
		[type]="'search'"
		[name]="'Searchby'"
		[maxlength]="100"
		[placeholder]="'Search by title'"
		(controlKeyup)="onSearchTextChange('title', $event)">
	</cv-input>
	<ag-grid-angular
		#grid
		class="ag-theme-balham custom-grid"
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="true"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		[rowData]="gridData"
	>
	</ag-grid-angular>
</div>
